import {makeEnumTypeGuard} from '../../../../libs/shared/helpers/src/typescript/enumHelpers';
import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {AppAction} from '../../appActions';

interface ChatUserOnlinePayload {
  conversationId: number;
}

export enum ChatUserOnlineActionsEnum {
  CHAT_USER_ONLINE_STATUS_CREATED = '@@data/chatUsersOnline/CHAT_USER_ONLINE_STATUS_CREATED',
  CHAT_USER_ONLINE_STATUS_DELETED = '@@data/chatUsersOnline/CHAT_USER_ONLINE_STATUS_DELETED',
}

export function createChatUserOnlineStatusAction(conversationId: number): AppAction {
  return {
    type: ChatUserOnlineActionsEnum.CHAT_USER_ONLINE_STATUS_CREATED,
    payload: {conversationId},
  };
}

export function deleteChatUserOnlineStatusAction(conversationId: number): AppAction {
  return {
    type: ChatUserOnlineActionsEnum.CHAT_USER_ONLINE_STATUS_DELETED,
    payload: {conversationId},
  };
}

export interface ChatUserOnlineCreatedAction extends ActionWithPayload<ChatUserOnlinePayload> {
  type: ChatUserOnlineActionsEnum.CHAT_USER_ONLINE_STATUS_CREATED;
}

export interface ChatUserOnlineDeletedAction extends ActionWithPayload<ChatUserOnlinePayload> {
  type: ChatUserOnlineActionsEnum.CHAT_USER_ONLINE_STATUS_DELETED;
}

export type ChatUserOnlineAction = ChatUserOnlineCreatedAction | ChatUserOnlineDeletedAction;

const isChatPusherActionType = makeEnumTypeGuard(ChatUserOnlineActionsEnum);

export function isChatUserOnlineAction(action: AppAction) {
  return isChatPusherActionType(action.type);
}
